<div class="container-login-general">

    <img src="assets/img/homepage-businesses-1.jpg" class="img-login">

    <div class="container-login-general-info-content">
        <div class="logo-login">
            <img src="assets/img/logo.svg">
        </div>
        <div class="container">
            <div class="row">
                <div class="container-login">
                    <div class="row">
                        <div class="col-md-12">
                            <h1 class="">Bienvenido</h1>
                            <form class="w-100"
                                [formGroup]="formularioAdicionar"
                                autocomplete="off">
                                <div class="form-group">
                                    <mat-form-field class="w-100" appearance="fill">
                                        <mat-label>Usuario</mat-label>
                                        <input matInput
                                                formControlName="usuario"
                                                placeholder="Ingrese el usuario"
                                                [value]="">
                                        <mat-icon matPrefix class="me-2">contact_mail</mat-icon>
                                        <span class="form-text text-danger"
                                                *ngIf="validateField('usuario')">
                                                Usuario es requerido
                                        </span>
                                    </mat-form-field>
                                </div>
                                <div class="form-group">
                                    <mat-form-field class="w-100" appearance="fill">
                                        <mat-label>Contraseña</mat-label>
                                        <input matInput
                                                type="password"
                                                formControlName="clave"
                                                placeholder="Ingrese su contraseña"
                                                value="">
                                        <mat-icon matPrefix class="me-2">email</mat-icon>
                                        <span class="form-text text-danger"
                                                *ngIf="validateField('clave')">
                                                Contraseña es requerida
                                        </span>
                                    </mat-form-field>
                                </div>
                                <div class="text-center mb-4">

                                    <button type="submit"
                                            class="btn red mb-2"
                                            (click)="login()">
                                        <span>Ingresar</span><span class="btn-arrow"></span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <app-footer></app-footer>
    </div>
</div>
